<script setup lang="ts">

import {useLocalizeStore} from "@/WebApp/Stores/LocalizeStore.ts";
import {onMounted} from "vue";
const localizeStore = useLocalizeStore();

onMounted(async () => {
	await localizeStore.getTranslationList();
});

</script>

<template>
	<RouterView/>
</template>
